import React from 'react'
import OverviewTable from '../components/ComparisonTable/Tables/OverviewTable';
import StandardFeature from '../components/ComparisonTable/Tables/StandardFeature';


export default function ComparisonTable() {
    return (
        <>
            <OverviewTable />
            <br />
            <StandardFeature />
        </>
    )
}

